export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pl": {
        "Temperature [°C]": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Temperatura [°C]"])},
        "Temperature Year Ago [°C]": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Temperatura Rok Temu [°C]"])},
        "Pressure [hpa]": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ciśnienie [hpa]"])},
        "Humidity [%]": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wilgotność [%]"])},
        "Rain [mm]": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opad [mm]"])},
        "Wind Speed [km/h]": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiatr Prędkość [km/h]"])},
        "Wind Gust [km/h]": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiatr Porywy [km/h]"])},
        "Wind Direction [°]": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiatr Kierunek [°]"])}
      }
    }
  })
}
